import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { style } from "./tab-menu-item.styles";

@customElement('sbk-tab-menu-item')
export class TabItem extends LitElement {
  @property({ type: Boolean, reflect: true }) active = false;

  @property()
  href = '';

  @property()
  size?: 'large' | 'medium' | 'small' | 'extra-small' = 'large';

  static get styles() {
    return style;
  }

  constructor() {
    super();
    this.addEventListener("click", this.onClick);
  }

  private onClick() {
    const category = this.getAttribute("data-category");
    this.dispatchEvent(new CustomEvent("category-change", {
      detail: { category },
      bubbles: true,  // Allows event to bubble up the DOM
      composed: true  // Allows event to cross shadow DOM boundaries
    }));
  }

  render() {
    return html`
        ${this.href ? this.renderLink() : this.renderButton()}
    `;
  }

  renderLink() {
    return html`
      <a class=${this.getTabMenuItemClass()} href=${this.href}>
        <slot></slot>
        <span class="tab-item__border"></span>
      </a>
    `;
  }

  renderButton() {
    return html`
      <button class=${this.getTabMenuItemClass()}>
        <slot></slot>
        <span class="tab-item__border"></span>
      </button>
    `;
  }

  getTabMenuItemClass() {
    return `
      tab-item
      ${this.size ? `tab-item--${this.size}` : ''}
      ${this.active ? 'tab-item--active' : ''}
    `.trim().replace(/\s+/g, ' ');
  }
}